import { gql } from '@apollo/react-hooks'

export const CREATE_SESSION = gql`
  mutation LoginAdmin($data: AuthInput!) {
    result: loginAdmin(data: $data) {
      token
      user {
        id
        name
        email
        role
      }
    }
  }
`
